import { motion } from 'framer-motion'
import Link from '../components/LocalizedLink'
import { Clock, Wrench, Layers, FileSpreadsheet, Download, ArrowRight } from 'lucide-react'
import { useLanguage } from '../contexts/LanguageContext'
import SEO from '../components/SEO'

const BASE = import.meta.env.BASE_URL

const translations = {
  el: {
    hero: {
      title: 'Πρόγραμμα Κοστολόγησης Φρέζας CNC',
      subtitle: 'Κοστολογήστε εξαρτήματα φρέζας CNC router από το σχέδιο: χρόνος μηχανής, φθορά εργαλείου, διατρήσεις, υλικό φύλλου, εργατικά και ρεύμα, σε μία τιμή ανά τεμάχιο.',
      cta1: 'Δωρεάν Δοκιμή',
      cta2: 'Δείτε Τιμές',
    },
    intro: {
      title: 'Πώς κοστολογείται ένα εξάρτημα φρέζας',
      body: 'Το κόστος φρεζαρίσματος εξαρτάται κυρίως από το μήκος της διαδρομής του εργαλείου, τον αριθμό των βυθίσεων (plunges), τη φθορά του κοπτικού και την ωριαία χρέωση της μηχανής. Το Workshop Assistant διαβάζει τη γεωμετρία από αρχεία DXF ή STEP, μετρά περιμέτρους και οπές και εφαρμόζει τις δικές σας τιμές μηχανής, εργαλείου και υλικού, χωρίς υπολογισμούς με το χέρι.',
    },
    features: {
      title: 'Τι υπολογίζει η κοστολόγηση φρέζας',
      items: [
        { icon: 'clock', title: 'Χρόνος Μηχανής', description: 'Χρόνος κοπής από το μήκος διαδρομής και χρόνος βύθισης ανά οπή, με ωριαία χρέωση μηχανής, εργατικά και κατανάλωση ρεύματος.' },
        { icon: 'wrench', title: 'Φθορά Εργαλείου', description: 'Ορίστε διάμετρο, κόστος και διάρκεια ζωής του κοπτικού σε μέτρα κοπής· η φθορά χρεώνεται αναλογικά σε κάθε εξάρτημα.' },
        { icon: 'layers', title: 'Υλικό Φύλλου', description: 'Κόστος ανά m² και διαστάσεις φύλλου για πολυκαρβονικό, MDF, κόντρα πλακέ και μασίφ ξύλο.' },
        { icon: 'excel', title: 'Προσφορά σε Excel', description: 'Ξεχωριστή προσφορά για τα εξαρτήματα φρέζας, με πλήρη ανάλυση κόστους ανά τεμάχιο, έτοιμη για τον πελάτη.' },
      ],
    },
    scope: {
      title: 'Για ποια εργασία είναι',
      body: 'Η κοστολόγηση φρέζας του Workshop Assistant καλύπτει 2D κοπή προφίλ και οπών σε φύλλα με CNC router. Στο ίδιο πρόγραμμα κοστολογείτε και τα μεταλλικά εξαρτήματα λαμαρίνας (laser, ψαλίδι, στράντζα), ώστε ένα έργο με μεταλλικά και μη μεταλλικά κομμάτια να βγαίνει σε μία διαδικασία.',
    },
    faq: [
      { q: 'Ποια υλικά υποστηρίζει η κοστολόγηση φρέζας CNC;', a: 'Πολυκαρβονικό, MDF, κόντρα πλακέ και μασίφ ξύλο, με κόστος ανά m² και τυπικές διαστάσεις φύλλου που ορίζετε εσείς. Τα μεταλλικά εξαρτήματα (χάλυβας, ανοξείδωτο, αλουμίνιο) κοστολογούνται ως λαμαρίνα με laser ή ψαλίδι και στράντζα.' },
      { q: 'Κοστολογεί κατεργασία μετάλλων σε κέντρο κατεργασίας ή τόρνο;', a: 'Όχι. Το Workshop Assistant κοστολογεί 2D φρεζάρισμα φύλλων με CNC router και εξαρτήματα λαμαρίνας. Δεν υπολογίζει 3-αξονική κατεργασία συμπαγών μεταλλικών τεμαχίων ή τόρνευση.' },
      { q: 'Πώς υπολογίζεται ο χρόνος φρεζαρίσματος;', a: 'Από το συνολικό μήκος κοπής του εξαρτήματος και τον αριθμό των βυθίσεων, με τον ρυθμό βύθισης και τον χρόνο ανά βύθιση που ορίζετε στις ρυθμίσεις router.' },
      { q: 'Μπορώ να βάλω τις δικές μου τιμές μηχανής και εργαλείων;', a: 'Ναι. Χρέωση έναρξης, ποσοστό κέρδους, ισχύς μηχανής, τιμή ρεύματος, εργατοώρα, ωριαία χρέωση μηχανής και στοιχεία εργαλείου ρυθμίζονται όλα από τον Επεξεργαστή Παραμέτρων.' },
    ],
    related: 'Δείτε επίσης',
    cta: { title: 'Κοστολογήστε την Επόμενη Δουλειά Φρέζας', subtitle: 'Κατεβάστε τη δωρεάν δοκιμή και βγάλτε προσφορά για εξαρτήματα CNC router σε λεπτά.', btn: 'Δωρεάν Δοκιμή' },
  },
  en: {
    hero: {
      title: 'CNC Milling Costing Software for Router Parts',
      subtitle: 'Cost CNC router milling jobs straight from the drawing: machine time, tool wear, plunges, sheet material, labor and electricity, rolled into one price per part.',
      cta1: 'Download Free Trial',
      cta2: 'View Pricing',
    },
    intro: {
      title: 'How a milled part is costed',
      body: 'Milling cost is driven mainly by toolpath length, the number of plunges, cutter wear and the machine\'s hourly rate. Workshop Assistant reads the geometry from DXF or STEP files, measures perimeters and holes, and applies your own machine, tooling and material rates, so you never work out machining time by hand.',
    },
    features: {
      title: 'What the milling cost estimate includes',
      items: [
        { icon: 'clock', title: 'Machine Time', description: 'Cutting time from toolpath length plus plunge time per hole, charged at your machine hourly rate, labor rate and electricity use.' },
        { icon: 'wrench', title: 'Tool Wear', description: 'Set the cutter diameter, cost and tool life in metres of cut; wear is charged to every part in proportion to its cut length.' },
        { icon: 'layers', title: 'Sheet Material', description: 'Cost per m² and standard sheet size for polycarbonate, MDF, plywood and hardwood.' },
        { icon: 'excel', title: 'Excel Quote', description: 'A separate offer for milled parts with a full per-part cost breakdown, ready to send to the customer.' },
      ],
    },
    scope: {
      title: 'What kind of milling it covers',
      body: 'Workshop Assistant\'s milling costing covers 2D profile and hole cutting on sheet stock with a CNC router. The same program also costs your sheet metal parts (laser, guillotine, press brake), so a project that mixes metal and non-metal parts is quoted in one pass.',
    },
    faq: [
      { q: 'Which materials does CNC milling costing support?', a: 'Polycarbonate, MDF, plywood and hardwood, with a cost per m² and standard sheet size you set. Metal parts (steel, stainless steel, aluminum) are costed as sheet metal with laser or guillotine cutting and press brake bending.' },
      { q: 'Does it cost metal machining on a machining centre or lathe?', a: 'No. Workshop Assistant costs 2D CNC router milling of sheet stock and sheet metal parts. It does not estimate 3-axis machining of solid metal blocks or turning.' },
      { q: 'How is milling time calculated?', a: 'From the total cut length of the part and the number of plunges, using the plunge rate and plunge time you set in the router settings.' },
      { q: 'Can I use my own machine and tooling rates?', a: 'Yes. Setup fee, profit markup, machine power, electricity rate, labor rate, machine hourly rate and tool details are all editable in the Parameters Editor.' },
    ],
    related: 'Related',
    cta: { title: 'Quote Your Next Milling Job', subtitle: 'Download the free trial and price CNC router parts in minutes.', btn: 'Download Free Trial' },
  },
}

const related = {
  el: [
    { name: 'Λογισμικό Εκτίμησης Κόστους Κατασκευής', path: '/manufacturing-cost-estimator' },
    { name: 'Κοστολόγηση Μεταλλικών Εξαρτημάτων', path: '/metal-parts-costing' },
    { name: 'Δωρεάν Υπολογιστής Κόστους', path: '/cost-calculator' },
  ],
  en: [
    { name: 'Manufacturing Cost Estimator', path: '/manufacturing-cost-estimator' },
    { name: 'Metal Parts Costing', path: '/metal-parts-costing' },
    { name: 'Free Cost Calculator', path: '/cost-calculator' },
  ],
}

const icons = { clock: <Clock className="h-10 w-10" />, wrench: <Wrench className="h-10 w-10" />, layers: <Layers className="h-10 w-10" />, excel: <FileSpreadsheet className="h-10 w-10" /> }

const CncMillingCosting = () => {
  const { lang } = useLanguage()
  const t = translations[lang]

  return (
    <div className="overflow-hidden">
      <SEO
        title="CNC Milling & Machining Costing Software"
        description="CNC milling costing software for router parts: estimate machine time, tool wear, plunges, sheet material and labor from DXF/STEP files, then send an Excel quote. Free trial."
        path="/cnc-milling-costing"
        faq={t.faq}
      />

      <section className="bg-gradient-to-br from-primary-600 to-primary-800 text-white">
        <div className="section-container">
          <div className="max-w-4xl mx-auto text-center">
            <motion.h1 initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="text-5xl md:text-6xl font-bold mb-6">{t.hero.title}</motion.h1>
            <motion.p initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.1 }} className="text-xl opacity-90 mb-8">{t.hero.subtitle}</motion.p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/download" className="flex items-center justify-center space-x-2 px-8 py-4 bg-white text-primary-600 rounded-lg font-semibold hover:bg-gray-100 transition-all duration-200 shadow-lg">
                <Download className="h-5 w-5" /><span>{t.hero.cta1}</span>
              </Link>
              <Link to="/pricing" className="flex items-center justify-center space-x-2 px-8 py-4 bg-transparent border-2 border-white text-white rounded-lg font-semibold hover:bg-white hover:text-primary-600 transition-all duration-200">
                <span>{t.hero.cta2}</span><ArrowRight className="h-5 w-5" />
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className="section-container bg-white">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-3xl font-bold mb-4">{t.intro.title}</h2>
            <p className="text-lg text-gray-600">{t.intro.body}</p>
          </div>
          <div className="rounded-2xl overflow-hidden shadow-2xl border border-gray-200">
            <img src={`${BASE}screenshots/calculator.png?v=2`} alt={t.hero.title} className="w-full h-auto object-cover" />
          </div>
        </div>
      </section>

      <section className="section-container bg-gray-50">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold mb-4">{t.features.title}</h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {t.features.items.map((f, i) => (
            <motion.div key={i} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.05 }} className="card">
              <div className="text-primary-600 mb-4">{icons[f.icon]}</div>
              <h3 className="text-xl font-semibold mb-2">{f.title}</h3>
              <p className="text-gray-600">{f.description}</p>
            </motion.div>
          ))}
        </div>
      </section>

      <section className="section-container bg-white">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-3xl font-bold mb-4">{t.scope.title}</h2>
          <p className="text-lg text-gray-600">{t.scope.body}</p>
        </div>
      </section>

      <section className="section-container bg-gray-50">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-3xl font-bold mb-8 text-center">FAQ</h2>
          <div className="space-y-4">
            {t.faq.map((item, i) => (
              <details key={i} className="card group">
                <summary className="font-semibold cursor-pointer list-none flex justify-between items-center">
                  {item.q}
                  <span className="text-primary-600 group-open:rotate-45 transition-transform">+</span>
                </summary>
                <p className="text-gray-600 mt-3">{item.a}</p>
              </details>
            ))}
          </div>
          <h2 className="text-2xl font-bold mt-12 mb-4">{t.related}</h2>
          <ul className="space-y-2">
            {related[lang].map((r) => (
              <li key={r.path}>
                <Link to={r.path} className="inline-flex items-center gap-2 font-semibold text-primary-600 hover:text-primary-700">
                  {r.name}<ArrowRight className="h-4 w-4" />
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section className="section-container bg-gradient-to-br from-gray-900 to-gray-800 text-white">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl font-bold mb-6">{t.cta.title}</h2>
          <p className="text-xl mb-8 opacity-90">{t.cta.subtitle}</p>
          <Link to="/download" className="inline-flex items-center space-x-2 px-8 py-4 bg-primary-600 text-white rounded-lg font-semibold hover:bg-primary-700 transition-all duration-200 shadow-lg">
            <Download className="h-5 w-5" /><span>{t.cta.btn}</span>
          </Link>
        </div>
      </section>
    </div>
  )
}

export default CncMillingCosting
